"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBroaderCollectionProperty = exports.broaderCollectionPropertyDefinition = void 0;
exports.broaderCollectionPropertyDefinition = {
    view: { label: 'Parent' },
    constraints: [
        {
            name: 'stencils',
            argument: ['collection'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'broader-collection',
};
const isBroaderCollectionProperty = (prop) => {
    return prop.name === exports.broaderCollectionPropertyDefinition.name;
};
exports.isBroaderCollectionProperty = isBroaderCollectionProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJvYWRlci1jb2xsZWN0aW9uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYnJvYWRlci1jb2xsZWN0aW9uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtJQUN6QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLFlBQVksQ0FBQztTQUN6QjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxvQkFBb0I7Q0FDSyxDQUFBO0FBSTFCLE1BQU0sMkJBQTJCLEdBQUcsQ0FBQyxJQUFrQixFQUFxQyxFQUFFO0lBQ25HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywyQ0FBbUMsQ0FBQyxJQUFJLENBQUE7QUFDL0QsQ0FBQyxDQUFBO0FBRlksUUFBQSwyQkFBMkIsK0JBRXZDIn0=